import React, { useState } from 'react';

const LoginForm = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await onLogin({ username, password });
    if (!success) {
      setError('Credenciales incorrectas');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#58735A] to-[#3F1907]">
      <div className="bg-[#F9EFD7] p-8 rounded-lg shadow-xl w-full max-w-md">
        <div className="flex justify-center mb-6">
          <img 
            src="https://4tsix0yujj.ufs.sh/f/2vMRHqOYUHc0UPtKdi4lpN4OwGAX7ky90Ihqt2Z5MKWHdTfQ" 
            alt="Logo POS" 
            className="h-20"
          />
        </div>
        <h2 className="text-2xl font-bold text-center text-[#3F1907] mb-6">Iniciar Sesión</h2>
        {error && (
          <div className="mb-4 p-2 bg-red-100 text-red-700 rounded-md text-sm">
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-[#3F1907] text-sm font-bold mb-2" htmlFor="username">
              Usuario
            </label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
              required
            />
          </div>
          <div className="mb-6">
            <label className="block text-[#3F1907] text-sm font-bold mb-2" htmlFor="password">
              Contraseña
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-[#58735A] hover:bg-[#3F1907] text-[#F9EFD7] font-bold py-2 px-4 rounded-md transition duration-200"
          >
            Ingresar
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;